import { ICreateContratoFinanceiroUseCase } from "../../../presentation/useCases/create/create_contrato_financeiro_use_case";
import { ContratoFinanceiro } from "../../models/contrato_financeiro";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * CreateContratoFinanceiroUseCase
 */

export class CreateContratoFinanceiroUseCase implements ICreateContratoFinanceiroUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async createContratoFinanceiro(form: ContratoFinanceiro): Promise<number> {
    return await this.repository.createContratoFinanceiro(form);

  }

}
